export interface TabItem {
  key: string;
  label: string;
  badge?: number;
}

// Simple underline tab-bar for switching sub-views on one admin page
// without full navigation. No existing shared component for this in the
// codebase yet — built once here, reusable wherever else it's needed.
export function Tabs({ tabs, active, onChange }: { tabs: TabItem[]; active: string; onChange: (key: string) => void }) {
  return (
    <div className="flex items-center gap-1 border-b border-border-subtle">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          type="button"
          onClick={() => onChange(tab.key)}
          className={`relative px-4 py-2.5 text-[13px] font-semibold transition-colors cursor-pointer ${
            active === tab.key ? 'text-primary-800' : 'text-ink-faint hover:text-ink'
          }`}
        >
          <span className="flex items-center gap-1.5">
            {tab.label}
            {!!tab.badge && (
              <span className="text-[10px] font-bold px-1.5 py-0.5 rounded-full bg-warning-bg text-warning">{tab.badge}</span>
            )}
          </span>
          {active === tab.key && <span className="absolute left-0 right-0 -bottom-px h-[2px] bg-primary-800 rounded-full" />}
        </button>
      ))}
    </div>
  );
}
